export default __webpack_public_path__ + "static/media/flag-china-inactive.e4a1d09c.svg";